import styled from 'styled-components';

export const FilterButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
`

export const WhiteButton = styled.div<{
    active: boolean
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 35px;
  ${({active}) => `
    color: ${active ? '#FFFFFF' : '#629361'};
    background: ${active ? '#629361' : 'linear-gradient(0deg, #FFFFFF, #FFFFFF), #009688'};
  `};
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.24);
  border-radius: 10px;
  font-size: 12px;

  :hover {
    cursor: pointer;
  }
`

export const LogicSwitchBlock = styled.div`
  display: flex;
  width: 128px;
  padding: 3px;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  background: linear-gradient(0deg, #FFFFFF, #FFFFFF), #009688;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.24);
  border-radius: 10px;
`

export const LogicBlockItem = styled.div<{
    isActive?: boolean
}>`
  display: flex;
  width: 50%;
  padding: 5px 20px;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  font-size: 14px;
  transition: all 0.2s linear;

  ${({isActive}) => isActive
    ?
    `
        color: white;
        background: linear-gradient(0deg, #2C80FF, #2C80FF), #009688;
    `
    :
    `
        color: #2C80FF;
        background: none;

        :hover {
            cursor: pointer;
            color: white;
            background: #89def4;
        }
    `
}
`

export const Container = styled.div`
  padding: 24px 11px 29px 15px;
  font-family: "SF Pro Display", sans-serif;

  > div:nth-child(n + 2) {
    margin-top: 12px;
  }
`

export const DecisionButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 120px;
`

export const DecisionButton = styled.div<{
    action: string
    disabled?: boolean
}>`
  ${({action}) => action === 'apply'
    ? 'background: linear-gradient(0deg, #629361, #629361), #009688;'
    : 'background: linear-gradient(0deg, #BD3636, #BD3636), #009688;'
};

  box-shadow: 0 0 2px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.24);
  border-radius: 10px;

  padding: 11px 17px;
  font-size: 12px;
  color: #FFFFFF;
  text-align: center;

  :hover {
    cursor: pointer;
  }
`
